export const TODAYS_BIRTHDAY = {
  BIRTHDAY_NOTIFICATION: "/todays-event/refresh",
  SEND_SMS: "/notification/initSMS",
  BIRTHDAY_DATA: "/todays-event/refresh",
};
